import React from 'react';
import Link from 'next/link';

import styles from './PostAuthor.module.scss';
import { IAuthor } from '../../lib/types';

interface PostAuthorProps {
  author: IAuthor;
}

const PostAuthor = (props: PostAuthorProps) => {
  const { author } = props;

  return (
    <div className={styles['post-author']}>
      {author.slug && author.name && (
        <Link href={`/author/[slug]`} as={`/author/${author.slug}`}>
          <a title={author.name}>{author.name}</a>
        </Link>
      )}
    </div>
  );
};

export default PostAuthor;
